import HeaderAsideLayout from '@/layouts/HeaderAsideLayout'
import NotFound from '@/pages/NotFound'
import Dashboard from '@/pages/Dashboard'
// import login from '@/pages/user/login'
import RecruitmentList from '@/pages/Admin/recruitment-list'
import SignUp from '@/pages/Examinee/SignUp'
import RecruitmentPoint from '@/pages/Admin/recruitment-point'
import AdminManage from '@/pages/Admin/admin-manage'
//基础路由(不需要登录)
export const baseRouter = [
    {
        path: '/login',
        component: () => import('@/pages/user/login')
    },
    {
        path: '/register',
        component: () => import('@/pages/user/register')
    },
    {
        path: '/findPwd',
        component: () => import('@/pages/user/findPwd')
    },
    {
        path: '/recruitDetail/:id',
        component: () => import('@/pages/user/recruit'),
        meta: {
            baseUrl: '/recruitDetail'
        }
    },
    {
        path: '/404',
        component: NotFound
    }
]
// 布局路由
// const layoutRouter = {
//     path: '/',
//         component: HeaderAsideLayout,
// }
//通用路由
const commonRouter = [
    {
        path: '/common',
        meta: { title: '其他信息' },
        component: HeaderAsideLayout,
        children: [
            {
                path: '/common/notice',
                component: () => import('@/pages/Notice')
            },
            {
                path: '/common/contentDetails/:id',
                meta: { title: '通知详情' },
                component: () => import('@/pages/ContentDetails')
            },
            {
                path: '/common/userCenter',
                meta: { title: '我的信息' },
                component: () => import('@/pages/user/userCenter')
            }
        ]
    },
    {
        path: '/imageview',
        component: () => import('@/pages/Admin/image-view')
    }
];

//管理员路由
export const adminRouter = commonRouter.concat([
           {
               path: '/',
               meta: { title: '首页' },
               component: HeaderAsideLayout,
               children: [
                   {
                       path: '/',
                       meta: { title: '首页统计' },
                       component: () => import('@/pages/Admin/index'),
                       children: []
                   }
               ]
           },
           {
               path: '/recruitment',
               component: HeaderAsideLayout,
               meta: { title: '招考信息' },
               children: [
                   {
                       path: '/recruitment/list',
                       component: RecruitmentList,
                       meta: { title: '招考列表' }
                   },

                   {
                       path: '/recruitment/point',
                       meta: { title: '考点维护' },
                       component: RecruitmentPoint
                   }
               ]
           },
           {
               path: '/signup',
               component: HeaderAsideLayout,
               meta: { title: '考生管理' },
               children: [
                   {
                       path: '/signup/list',
                       meta: { title: '报考审查' },
                       component: () => import('@/pages/Admin/signup-list')
                   },

                   {
                       path: '/signup/achievement',
                       meta: { title: '成绩管理' },
                       component: () =>
                           import('@/pages/Admin/signup-achievement')
                   }
               ]
           }
       ]);

//考生路由
export const examineeRouter = commonRouter.concat([
    {
        path: '/', meta: { title: '首页' },
        component: HeaderAsideLayout,
        children: [
            {
                path: '/', meta: { title: '招考列表' },
                component: ()=>import('@/pages/Dashboard'),
                children: []
            }
        ]
    },
    {
        path: '/examinee',
        component: HeaderAsideLayout,
        meta: {
            title: '我的报考'
        },
        children: [
            {
                path: '/examinee/index',
                meta: { title: '报考记录' },
                component: () => import('@/pages/Examinee/index')
            },
            {
                path: '/examinee/achievement',
                meta: { title: '成绩查询' },
                component: () => import('@/pages/Examinee/achievement')
            },
            {
                path: '/doSignUp/:id',
                meta: { title: '立即报名' },
                component: () => import('@/pages/Examinee/SignUp')
            },
            {
                path: '/doSignUp/:isEdit/:id/:applyId',
                meta: { title: '编辑报名' },
                component: () => import('@/pages/Examinee/SignUp')
            }
        ]
    }
])

//超级管理员路由
export const rootRouter = adminRouter.concat([
    {
        path: '/setting',
        component: HeaderAsideLayout,
        meta: {
            title: '系统设置'
        },
        children: [
            {
                path: '/setting/admin',
                component: AdminManage,
                meta: {
                    title: '管理员维护'
                }
            }
        ]
    }
])

// const routerConfig = [
//     {
//         path: '/login',
//         component: login
//     },
//     {
//         path: '/',
//         component: HeaderAsideLayout,
//         children: [
//             { path: '/dashboard/analysis', component: Dashboard },
//             { path: '/dashboard/monitor', component: NotFound },
//             { path: '/dashboard/workplace', component: NotFound }
//         ]
//     },
//     { path: '*', component: NotFound }
// ]
